import PillButton from '@components/bits/PillButton';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';
type Props = {
  types;
  totalItems;
  updateFilters;
  activeFilters;
};

const ToolsFilterBar: FunctionComponent<Props> = ({
  types,
  totalItems = 0,
  updateFilters,
  activeFilters = {},
}) => {
  return (
    <div className={`${styles.root}`}>
      <PillButton text={`Vis alle (${totalItems})`} onClick={() => updateFilters('')} />
      {types?.map((val, key) => {
        const active = Object.keys(activeFilters).find((item) => {
          const check = item === val;
          return check;
        });

        return (
          <PillButton
            key={key}
            text={val}
            onClick={() => updateFilters(val)}
            active={active ? true : false}
          />
        );
      })}
    </div>
  );
};

export default React.memo(ToolsFilterBar);
